import { render, staticRenderFns } from "./adminSidebar.vue?vue&type=template&id=13975ccc&scoped=true&"
import script from "./adminSidebar.vue?vue&type=script&lang=ts&"
export * from "./adminSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./adminSidebar.vue?vue&type=style&index=0&id=13975ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13975ccc",
  null
  
)

export default component.exports